import React from "react";
import "../../styles/m3d-vantagens.css";

export default function CtaFinal() {
  return (
    <section className="cta-final">
      <div className="container-limited">
        <h2>Pronto para acumular?</h2>
        <p>Comece seu próximo projeto e ganhe pontos</p>
        <button className="btn-white">Solicitar orçamento</button>
      </div>
    </section>
  );
}
